import React, { useEffect } from "react";
import ScholarshipEventsBanner from "./components/ScholarshipEventsBanner";
import ScholarshipFairSponsors from "./components/ScholarshipFairSponsors";
import EventsParticipation from "./components/EventsParticipation";
import EventsQuickFacts from "./components/EventsQuickFacts";
import ParticipationProcedure from "./components/ParticipationProcedure";
import { Helmet, HelmetProvider } from "react-helmet-async";
import logo from "../../images/navbar/College Mentor_Final_Logo-01.png";
import config from "../../util/config";

const ScholarshipEvents = () => {
  // Update the document title and meta description when component mounts
  useEffect(() => {
    document.title = "College Mentor Scholarship Event 2025 - Register Now!";
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute(
        "content",
        "Join the College Mentor Scholarship Event 2025! Winners collect 1 crore* worth of prizes, students register for mentorship, and colleges partner as sponsors."
      );
  }, []);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          {/* Google Tag Manager Script */}
          <script
            async
            src={`https://www.googletagmanager.com/gtag/js?id=${config.GA_TRACKING_ID}`}
          ></script>
          <script>
            {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${config.GA_TRACKING_ID}');
            `}
          </script>

          {/* Basic meta tags */}
          <title>College Mentor Scholarship Event 2025 - Register Now!</title>
          <meta 
            name="description" 
            content="Join the College Mentor Scholarship Event 2025! Winners collect 1 crore* worth of prizes, students register for mentorship, and colleges partner as sponsors." 
          />
          <meta 
            name="keywords" 
            content="College Mentor Scholarship Event 2025, scholarship test winners, 1 crore scholarship prizes, College Mentor mentorship programs, College sponsorship opportunities, Mentorship for college students, College event sponsorship, Register for College Mentor Scholarship, Student mentorship programs, College Mentor event registration, scholarship event registration, College Mentor scholarships, apply for scholarships" 
          />
          <link rel="canonical" href={`${config.apiUrl}/college-mentor-scholarship/event`} />
          <meta name="robots" content="index, follow" />

          {/* Open Graph meta tags for Facebook */}
          <meta property="og:title" content="College Mentor Scholarship Event 2025 | Register Now!" />
          <meta property="og:description" content="Join us for the College Mentor Scholarship Event 2025! Students can collect scholarships worth 1 crore, register for mentorship programs, and colleges can partner as sponsors. Don't miss out!" />
          <meta property="og:url" content="https://www.collegementor.com/college-mentor-scholarship/event" />
          <meta property="og:image" content="https://www.collegementor.com/images/scholarship-event-banner.jpg" />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="College Mentor" />
          <meta property="og:locale" content="en_US" />
          <meta property="og:updated_time" content="2025-05-12T10:00:00Z" />

          {/* Twitter Card meta tags */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="College Mentor Scholarship Event 2025 | Register Now!" />
          <meta name="twitter:description" content="Students: Collect your 1 crore* worth scholarships & register for mentorship. Colleges: Partner with us. Join the College Mentor Scholarship Event 2025!" />
          <meta name="twitter:image" content="https://www.collegementor.com/images/scholarship-event-banner.jpg" />
          <meta name="twitter:url" content="https://www.collegementor.com/college-mentor-scholarship/event" />
          <meta name="twitter:site" content="@college_mentor_" />
          <meta name="twitter:creator" content="@college_mentor_" />

          {/* Schema.org JSON-LD structured data */}
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "http://schema.org",
              "@type": "Event",
              "name": "College Mentor Scholarship Event 2025",
              "startDate": "2025-05-12T10:00",
              "endDate": "2025-05-12T16:00",
              "location": {
                "@type": "Place",
                "name": "A Plus Convention Center",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "A Plus Convention Center, Municipal Employees Colony Main Road, Acharya Ranga Nagar, Benz Circle",
                  "addressLocality": "Vijayawada",
                  "addressRegion": "Andhra Pradesh",
                  "postalCode": "520010",
                  "addressCountry": "IN"
                }
              },
              "url": "https://www.collegementor.com/college-mentor-scholarship/event",
              "description": "We warmly invite you to join the College Mentor Scholarship Event 2025. This is more than just an opportunity to win scholarships worth 1 crore; it's a chance to be part of a community dedicated to your success.",
              "organizer": {
                "@type": "Organization",
                "name": "College Mentor",
                "url": "https://www.collegementor.com",
                "sameAs": [
                  "https://x.com/college_mentor_",
                  "https://www.linkedin.com/company/mycollegementor",
                  "https://www.facebook.com/people/My-College-Mentor/61570539353128/",
                  "https://www.instagram.com/college.mentor_insta"
                ],
                "contactPoint": {
                  "@type": "ContactPoint",
                  "telephone": "+91-7997166666",
                  "contactType": "College Mentor Scholarship Event 2025 - related Inquiries",
                  "areaServed": "IN",
                  "availableLanguage": "English"
                },
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "Plot 38, F301, Road no-1, Kakatiyahills, Madhapur, Shaikpet",
                  "addressLocality": "Hyderabad",
                  "addressRegion": "Telangana",
                  "postalCode": "500081",
                  "addressCountry": "IN"
                }
              },
              "offers": {
                "@type": "Offer",
                "url": "https://www.collegementor.com/college-mentor-scholarship/event",
                "priceCurrency": "INR",
                "price": "Free",
                "eligibleRegion": {
                  "@type": "Place",
                  "name": "India"
                }
              },
              "reservation": [
                {
                  "@type": "EventReservation",
                  "name": "Mentorship Program for College Students Registration",
                  "url": "https://www.collegementor.com/college-mentor-scholarship/event#student-form",
                  "reservationFor": {
                    "@type": "Service",
                    "name": "Mentorship Program for College Students",
                    "serviceType": "Mentorship program for college students",
                    "description": "Register for College Mentor's Mentorship Program to receive guidance and support in various academic and career areas for college students."
                  }
                },
                {
                  "@type": "EventReservation",
                  "name": "College Sponsorship & Collaboration Registration",
                  "url": "https://www.collegementor.com/college-mentor-scholarship/event#college-form",
                  "reservationFor": {
                    "@type": "Service",
                    "name": "College Sponsorship & Collaboration",
                    "serviceType": "Sponsorship for the event and future collaborations",
                    "description": "Register your college to participate as a sponsor for the College Mentor Scholarship Event 2025, and explore future collaboration opportunities with College Mentor."
                  }
                }
              ],
              "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://www.collegementor.com"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "College Mentor Scholarship",
                    "item": "https://www.collegementor.com/college-mentor-scholarship"
                  },
                  {
                    "@type": "ListItem",
                    "position": 3,
                    "name": "Event Registration",
                    "item": "https://www.collegementor.com/college-mentor-scholarship/event"
                  }
                ]
              },
              "image": {
                "@type": "ImageObject",
                "url": "https://www.collegementor.com/path-to-image.jpg",
                "height": "800",
                "width": "1200"
              },
              "eventStatus": "https://schema.org/EventScheduled",
              "audience": {
                "@type": "Audience",
                "audienceType": "Students, Colleges, Education Enthusiasts"
              },
              "eventHead": {
                "@type": "Person",
                "name": "Mr. Raja Shaker Medagam",
                "url": "https://collegementor.com/mentor/raja-shekar-19",
                "sameAs": "https://www.linkedin.com/in/raja-shekar-medagam-bb1462334/"
              },
              "potentialAction": {
                "@type": "Action",
                "name": "Register for the College Mentor Scholarship Event",
                "target": "https://www.collegementor.com/college-mentor-scholarship/event#registration-form"
              },
              "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-8959591818",
                "contactType": "College Mentor Scholarship Event 2025 - related Inquiries",
                "areaServed": "IN",
                "availableLanguage": "English"
              },
              "partnerWithUs": {
                "@type": "ContactPoint",
                "telephone": "+91-9281409586",
                "contactType": "Partner with College Mentor Scholarship Event 2025",
                "areaServed": "IN",
                "availableLanguage": "English"
              },
              "partnerWithUs2": {
                "@type": "ContactPoint",
                "telephone": "+91-9948115999",
                "contactType": "Partner with College Mentor Scholarship Event 2025",
                "areaServed": "IN",
                "availableLanguage": "English"
              }
            })}
          </script>
        </Helmet>
      </HelmetProvider>
      <div>
        <ScholarshipEventsBanner />
        <ScholarshipFairSponsors />
        <EventsParticipation />
        <EventsQuickFacts />
        <ParticipationProcedure />
      </div>
    </>
  );
};

export default ScholarshipEvents;
